import { isValidMail } from '../../../../../../Common/Resources/src_front/js/helper-functions/isValidMail';

export function initModalCreateAccountEmailFull(modal) {
    // VARS
    const form = document.querySelector('[data-modal-funnel-full]');
    if (!form) return;
    const submitEmail = form.querySelector('[data-modal-create-account-submit]');
    const userEmail = form.querySelector('[data-modal-create-account-email]');
    const fieldsSelector = {
        userEmail: '[data-modal-create-account-email]',
    };
    const classShowErrorMessage = 'is-error';
    let isValidForm = true;

    // LISTENERS
    submitEmail.addEventListener('click', handleOnSubmit, false);

    userEmail.addEventListener('focus', handleOnFocusInputEmail, false);

    document.addEventListener('keydown', handleOnPressEnter, false);

    // HANDLERS
    function handleOnSubmit(event) {
        validateForm(event);
    }

    function handleOnFocusInputEmail() {
        hideErrorMessage(fieldsSelector.userEmail);
    }

    function handleOnPressEnter(event) {
        if (event.key === 'Enter' && document.activeElement.hasAttribute('data-modal-create-account-email')) {
            validateForm(event);
        }
    }

    // METHODS & FUNCTIONS
    function validateForm(event) {
        validateUserEmail();

        if (isValidForm) {
            isValidForm;
        } else {
            event.preventDefault();
            isValidForm = true;
        }
    }

    function validateUserEmail() {
        hideErrorMessage(fieldsSelector.userEmail);

        if (!userEmail.value.trim()) {
            showErrorMessage(fieldsSelector.userEmail, 'required');
            isValidForm = false;
        } else if (!isValidMail(userEmail.value.trim())) {
            showErrorMessage(fieldsSelector.userEmail, 'invalid');
            isValidForm = false;
        } else {
            hideErrorMessage(fieldsSelector.userEmail);
        }
    }

    function hideErrorMessage(selector) {
        const field = document.querySelector(selector);
        const errors = field.closest('[data-input-wrapper]').querySelectorAll('[data-field-error]');

        field.classList.remove(classShowErrorMessage);
        [...errors].forEach((error) => {
            error.classList.remove(classShowErrorMessage);
        });
    }

    function showErrorMessage(selector, type) {
        const field = document.querySelector(selector);
        const error = field.closest('[data-input-wrapper]').querySelector(`[data-field-error="${type}"]`);

        field.classList.add(classShowErrorMessage);
        error.classList.add(classShowErrorMessage);
    }
}
